import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { StreamState } from "@service/companion-streaming.service";

export interface AvatarState {
  text: string | null;
  muted: boolean;
  subtitlesOn: boolean;
  talking: boolean;
  processing: boolean;
  initializing: boolean;
  ready: boolean;
  loadingConfig: boolean;
  streamState: StreamState | null;
}

const initialState: AvatarState = {
  text: null,
  muted: false,
  subtitlesOn: false,
  talking: false,
  processing: false,
  initializing: false,
  ready: false,
  loadingConfig: false,
  streamState: null,
};

export const avatarSlice = createSlice({
  name: "avatar",
  initialState,
  reducers: {
    setText: (state, action: PayloadAction<string | null>) => {
      state.text = action.payload;
    },
    addText: (state, action: PayloadAction<string>) => {
      state.text = state.text ? state.text + action.payload : action.payload;
    },
    setTalking: (state, action: PayloadAction<boolean>) => {
      state.talking = action.payload;
    },
    setProcessing: (state, action: PayloadAction<boolean>) => {
      state.processing = action.payload;
    },
    setMuted: (state, action: PayloadAction<boolean>) => {
      state.muted = action.payload;
    },
    setSubtitlesOn: (state, action: PayloadAction<boolean>) => {
      state.subtitlesOn = action.payload;
    },
    setInitializing: (state, action: PayloadAction<boolean>) => {
      state.initializing = action.payload;
    },
    setLoadingConfig: (state, action: PayloadAction<boolean>) => {
      state.loadingConfig = action.payload;
    },
    setReady: (state, action: PayloadAction<boolean>) => {
      state.ready = action.payload;
    },
    setStreamState: (state, action: PayloadAction<StreamState | null>) => {
      state.streamState = action.payload;
    },
  },
});

export const {
  addText,
  setText,
  setMuted,
  setSubtitlesOn,
  setTalking,
  setProcessing,
  setInitializing,
  setLoadingConfig,
  setReady,
  setStreamState,
} = avatarSlice.actions;

export default avatarSlice.reducer;
